var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9213_276)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9213_276)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D80B0B",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_9213_276)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9213_276",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 11,
    width: 28,
    height: 28
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 11,
    width: 28,
    height: 28,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9213_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.1171 35.4977C24.7865 35.4977 24.5094 35.3859 24.2858 35.1622C24.0622 34.9386 23.9504 34.6615 23.9504 34.331C23.9504 34.1949 23.9796 34.0539 24.0379 33.9081C24.0962 33.7622 24.1837 33.631 24.3004 33.5143L29.2879 28.5268C29.4046 28.4102 29.4629 28.2692 29.4629 28.1039C29.4629 27.9386 29.4046 27.7977 29.2879 27.681C29.1712 27.5643 29.0303 27.5109 28.865 27.5206C28.6997 27.5303 28.5587 27.5935 28.4421 27.7102L23.4837 32.6685C23.3671 32.7852 23.2407 32.8727 23.1046 32.931C22.9684 32.9893 22.8226 33.0185 22.6671 33.0185C22.3365 33.0185 22.0594 32.9067 21.8358 32.6831C21.6122 32.4595 21.5004 32.1824 21.5004 31.8518C21.5004 31.6574 21.5296 31.497 21.5879 31.3706C21.6462 31.2442 21.724 31.1324 21.8212 31.0352L26.8087 26.0477C26.9254 25.931 26.9837 25.7949 26.9837 25.6393C26.9837 25.4838 26.9254 25.3477 26.8087 25.231C26.6921 25.1143 26.5559 25.056 26.4004 25.056C26.2448 25.056 26.1087 25.1143 25.9921 25.231L21.0046 30.1893C20.8879 30.306 20.7615 30.3935 20.6254 30.4518C20.4893 30.5102 20.3337 30.5393 20.1587 30.5393C19.8476 30.5393 19.5754 30.4227 19.3421 30.1893C19.1087 29.956 18.9921 29.6838 18.9921 29.3727C18.9921 29.2171 19.0212 29.0713 19.0796 28.9352C19.1379 28.799 19.2254 28.6727 19.3421 28.556L24.3004 23.5977C24.4171 23.481 24.4754 23.34 24.4754 23.1747C24.4754 23.0095 24.4171 22.8685 24.3004 22.7518C24.1837 22.6352 24.0476 22.5768 23.8921 22.5768C23.7365 22.5768 23.6004 22.6352 23.4837 22.7518L18.5254 27.7393C18.4282 27.8365 18.3115 27.9143 18.1754 27.9727C18.0393 28.031 17.874 28.0602 17.6796 28.0602C17.349 28.0602 17.0719 27.9484 16.8483 27.7247C16.6247 27.5011 16.5129 27.224 16.5129 26.8935C16.5129 26.7379 16.5421 26.5921 16.6004 26.456C16.6587 26.3199 16.7462 26.1935 16.8629 26.0768L22.5796 20.3602C22.7934 20.1463 23.0608 20.049 23.3816 20.0685C23.7025 20.0879 23.9698 20.2046 24.1837 20.4185L27.7421 23.9768C27.9559 24.1907 28.2087 24.3609 28.5004 24.4872C28.7921 24.6136 29.0837 24.6768 29.3754 24.6768C29.9976 24.6768 30.5421 24.4581 31.0087 24.0206C31.4754 23.5831 31.7087 23.024 31.7087 22.3435C31.7087 22.0713 31.6601 21.7893 31.5629 21.4977C31.4657 21.206 31.2907 20.9338 31.0379 20.681L27.0421 16.6852C26.8282 16.4713 26.6872 16.2379 26.6191 15.9852C26.5511 15.7324 26.5851 15.4893 26.7212 15.256C26.8962 14.9643 27.1198 14.7504 27.3921 14.6143C27.6643 14.4782 27.9657 14.4102 28.2962 14.4102C28.7046 14.4102 29.1226 14.5074 29.5504 14.7018C29.9782 14.8963 30.3671 15.1685 30.7171 15.5185L35.6462 20.4768C35.9962 20.8268 36.2539 21.2157 36.4191 21.6435C36.5844 22.0713 36.6671 22.5671 36.6671 23.131C36.6671 23.5199 36.5796 23.9136 36.4046 24.3122C36.2296 24.7109 35.9768 25.0754 35.6462 25.406L25.9337 35.1477C25.7782 35.3032 25.6421 35.4004 25.5254 35.4393C25.4087 35.4782 25.2726 35.4977 25.1171 35.4977ZM14.3837 25.1435C14.0143 24.8713 13.7372 24.5456 13.5525 24.1664C13.3678 23.7872 13.2754 23.3838 13.2754 22.956C13.2754 22.5088 13.3678 22.0713 13.5525 21.6435C13.7372 21.2157 14.0046 20.8268 14.3546 20.4768L19.2837 15.5185C19.6143 15.1879 19.9789 14.9352 20.3775 14.7602C20.7761 14.5852 21.199 14.4977 21.6462 14.4977C22.1323 14.4977 22.6039 14.5852 23.0608 14.7602C23.5178 14.9352 23.9115 15.1879 24.2421 15.5185L30.2212 21.4977C30.3184 21.5949 30.4011 21.7164 30.4691 21.8622C30.5372 22.0081 30.5712 22.1588 30.5712 22.3143C30.5712 22.6449 30.4594 22.922 30.2358 23.1456C30.0122 23.3692 29.7351 23.481 29.4046 23.481C29.249 23.481 29.0983 23.447 28.9525 23.3789C28.8066 23.3109 28.6851 23.2282 28.5879 23.131L25.0004 19.5727C24.5532 19.1254 24.0039 18.9018 23.3525 18.9018C22.7011 18.9018 22.1518 19.1254 21.7046 19.5727L16.2212 25.056C15.9684 25.3088 15.6719 25.44 15.3316 25.4497C14.9914 25.4595 14.6754 25.3574 14.3837 25.1435Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9213_276",
    x: 2,
    y: 2,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9213_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9213_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_9213_276",
    x: 7.27539,
    y: 8.41016,
    width: 43.3926,
    height: 41.0859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9213_276"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9213_276",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9213_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerown);
export default __webpack_public_path__ + "static/media/partnerown.7a172473a4b06f3c910f31a408b00a61.svg";
export { ForwardRef as ReactComponent };